
import { ActionTree } from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {


    /**
     * Create announcement - Super Admin route only
     *
     * @param state
     * @param getters
     * @param commit
     * @param dispatch
     * @param data
     */

    createAnnouncement: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            axios.post('/announcement',data)

                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

};
